import React, { useState, useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import ContactsCard from '../components/layout/ContactsCard';
import EmailCard from '../components/layout/EmailCard';
import MeetingsCard from '../components/layout/MeetingsCard';
import { useParams } from 'react-router-dom';
import { parseAPIData } from '../utilities/shared';
import config from '../config/config';
import axios from 'axios';

function SummaryPage() {
  let { selectName } = useParams();
  let { contact_id } = useParams();
  let { poc_id } = useParams();
  const [contactData, setContactData] = useState();
  const [meetingData, setMeetingData] = useState();
  const [emailData, setEmailData] = useState();
  const isReady = contactData !== undefined && meetingData !== undefined; //Use this instead of loadData

  //API calls
  async function getContactData() {
    axios
      .get(config.apiURL + `/contacts?name=${selectName}`, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((response) => {
        console.log(response.data);
        const contactData = response.data.map((obj) => parseAPIData(obj));
        setContactData(contactData);
      });
  }

  async function getEmailData() {
    axios
      .get(config.apiURL + `/contacts_emailed/poc_id/${poc_id}`, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((response) => {
        const emailData = response.data.map((obj) => parseAPIData(obj));
        setEmailData(emailData);
      });
  }

  async function getMeetingData() {
    axios
      .get(config.apiURL + `/contacts_meeting/contact_id/${contact_id}`, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((response) => {
        const meetingData = response.data.map((obj) => parseAPIData(obj));
        setMeetingData(meetingData);
      });
  }

  useEffect(() => {
    getContactData();
    getEmailData();
    getMeetingData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <Navbar />
      <div>
        <div style={{ textAlign: 'center' }}>
          <h2>Contact Information</h2>
          <h4>Profile: {selectName}</h4>
        </div>
        {isReady ? (
          <div className='row'>
            <ContactsCard contactData={contactData} />
            <EmailCard emailData={emailData} />
            <MeetingsCard meetingData={meetingData} />
          </div>
        ) : (
          <p>Loading Please wait...</p>
        )}
      </div>
    </div>
  );
}

export default SummaryPage;
